import React from "react"
var consult = require("./../../images/process/consult.png")
var concept = require("./../../images/process/concept.png")
var BIM = require("./../../images/process/BIM.png")
var design = require("./../../images/process/design.png")
var construct = require("./../../images/process/construct.png")
var ceompletion = require("./../../images/process/ceompletion.png")
const achievements1 = [
  {
    title: "Initial consultation",
    description:
      "Understanding client vision, site conditions, budget, and timeline.",
    date: "01",
    month: "Oct",
    year: "2013",
    icon: consult,
  },
  {
    title: " BIM integration",
    description:
      "LOD 300: Conceptual design. LOD 400: Detailed coordination. OD 500: As-built models for construction and management.",
    date: "03",
    month: "Mar",
    year: "2014",
    icon: BIM,
  },
  {
    title: " Construction & excution",
    description:
      " Managing construction with integrated services, quality control, and budget adherence.",
    date: "05",
    month: "Aug",
    icon: construct,
    year: "2014",
  },
]

const achievements2 = [
  {
    title: "  Concept design",
    description:
      " Initial concepts aligning with client goals, focusing on creativity, functionality, and sustainability.",
    date: "02",
    month: "Nov",
    year: "2015",
    icon: concept,
  },
  {
    title: "Design development",
    description:
      " Refining designs with client feedback and coordinating engineering for seamless integration.",
    date: "04",
    month: "Mar",
    icon: design,
    year: "2016",
  },
  {
    title: " Completion & handover",
    description:
      " Final inspections, quality checks, and delivery of as-built documentation and management models",
    date: "06",
    month: "July",
    icon: ceompletion,
    year: "2017",
  },
]

var bgimg1 = require("./../../images/background/bg-map.png")
var bgimg2 = require("./../../images/background/cross-line2.png")

class Achievements1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full p-t80 p-b50 sx-bg-secondry bg-no-repeat bg-bottom-center mobile-page-padding"
          style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="sx-separator-outer separator-center">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  style={{
                    backgroundImage: "url(" + bgimg2 + ")",
                    width: "100%",
                  }}
                >
                  <h3 className="sep-line-one">OUR PROCESS</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            <div className="section-content ">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 m-b30">
                  {achievements1.map((item, index) => (
                    <div className="sx-box our-story text-white" key={index}>
                      <div className="mt-media our-story-info d-flex justify-content-start">
                        {/* <div className="our-story-time"> */}
                        <h4 className="text-uppercase ">{item.date}</h4>
                        {/* <span className="month">{item.month}</span> */}
                        {/* </div> */}
                        <div className="our-story-year">
                          <img
                            src={item.icon}
                            style={{
                              width:
                                index == 0
                                  ? "60px"
                                  : index == 2
                                  ? "140px"
                                  : "180px",
                              height:
                                index == 0
                                  ? "20px"
                                  : index == 1
                                  ? "30px"
                                  : "30px",
                            }}
                            alt=""
                          ></img>
                        </div>
                      </div>
                      <div className="our-story-detail">
                        <h4 style={{ textTransform: "uppercase" }}>
                          {item.title}
                        </h4>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12">
                  {achievements2.map((item, index) => (
                    <div className="sx-box our-story text-white" key={index}>
                      <div className="mt-media our-story-info d-flex justify-content-start">
                        <h4 className="text-uppercase ">{item.date}</h4>
                        {/* <span className="month">{item.month}</span> */}
                        {/* </div> */}
                        <div className="our-story-year">
                          <img
                            src={item.icon}
                            style={{ width: "130px", height: "30px" }}
                            alt=""
                          ></img>
                        </div>
                      </div>
                      <div className="our-story-detail">
                        <h4 style={{ textTransform: "uppercase" }}>
                          {item.title}
                        </h4>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Achievements1
